import script from "./Upload.vue?vue&type=script&lang=ts"
export * from "./Upload.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__